import { Routes } from '@angular/router';
import { AuthGuard } from './modules/auth/services/auth.guard';

export const appRoutes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./modules/auth/auth.component').then((m) => m.AuthComponent),
    loadChildren: () =>
      import('./modules/auth/auth.routes').then((m) => m.routes),
  },
  {
    path: 'pay-now/:guid',
    loadComponent: () =>
      import('./modules/pay-now/pay-now.component').then(
        (m) => m.PayNowComponent
      ),
    loadChildren: () =>
      import('./modules/pay-now/pay-now.routes').then((m) => m.routes),
  },
  {
    path: 'form/:token',
    loadComponent: () =>
      import('./modules/send-form/send-form.component').then(
        (m) => m.SendFormComponent
      )
  },
    {
    path: 'policy-form/:token',
    loadComponent: () =>
      import('./modules/send-agreement-form/send-agreement-form.component').then(
        (m) => m.SendAgreementFormComponent
      )
  },
  {
    // Task/3424 (Refund Authenticator) - the public signing link a patient reaches from the
    // emailed/texted secure link (concept screen 4). Same pattern as policy-form/:token above.
    path: 'refund-settlement/:token',
    loadComponent: () =>
      import('./modules/refund-settlement-signing/refund-settlement-signing.component').then(
        (m) => m.RefundSettlementSigningComponent
      )
  },
  {
    path: 'error',
    loadComponent: () =>
      import('./modules/errors/errors.component').then(
        (m) => m.ErrorsComponent
      ),
    loadChildren: () =>
      import('./modules/errors/errors.routes').then((m) => m.routes),
  },
  {
    path: 'location-selection',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./modules/location-background-page/location-background-page.component').then(
        (m) => m.LocationBackgroundPageComponent
      ),
  },
  {
    path: '',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./_metronic/layout/layout.component').then(
        (m) => m.LayoutComponent
      ),
    loadChildren: () => import('../app/pages/routing').then((m) => m.Routing),
  },
  {
    path: 'other',
    loadChildren: () =>
      import('./modules/other-page/other-page.routes').then(
        (m) => m.OtherRoutes
      ),
  },
    {
    path: 'verify-invite-member/:token',
    loadComponent: () =>
      import('./modules/verify-practice-invite/verify-practice-invite.component').then(
        (m) => m.VerifyPracticeInviteComponent
      ),
  },
   
  { path: '**', redirectTo: 'error/404' },
];
